import { Autocomplete, useJsApiLoader } from "@react-google-maps/api";
import { get, getDatabase, onValue, push, ref } from "firebase/database";
import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  auth,
  db,
  onAuthStateChanged,
  storage,
} from "../../utilities/firebaseConfig";
import {
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";
import checked from "../../assets/checked.svg";
import filetericon from "../../assets/filtericon.svg";
import calendericon from "../../assets/tcalendar.svg";
import locationicon from "../../assets/tlocation.svg";
import { IoCloseOutline } from "react-icons/io5";
import unchecked from "../../assets/unchecked.svg";
import timeicon from "../../assets/ttime.svg";
import { useNavigate } from "react-router-dom";
import moment from "moment/moment";
import { Title } from "chart.js";
import Loader from "../Loader";
import { useAuth } from "../../utilities/Auth";
function PostJob({ isOpen, onClose, children }) {
  const [active, setActive] = useState("jobtitledescription");
  const [jobtitle, setJobtitle] = useState("");
  const [jobdescription, setJobdescription] = useState("");
  const [date, setDate] = useState(null);
  const [serviceType, setServiceType] = useState("");
  const [services, setServices] = useState([]);
  const [selecttday, setSelecttday] = useState("");
  const [address, setAddress] = useState("");
  const [time, setTime] = useState("");
  const [images, setImages] = useState([]);
  const [autocomplete, setAutocomplete] = useState(null);
  const [showSearchlist, setShowSearchlist] = useState(false);
  const [technicians, setTechnicians] = useState([]);
  const [filteredTechnicians, setFilteredTechnicians] = useState([]);
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [selectedLevel, setSelectedLevel] = useState("");
  const [minExperience, setMinExperience] = useState("");
  const [minRating, setMinRating] = useState("");
  const [activeprofile, setActiveprofile] = useState(null);
  const [tasksum, setTasksum] = useState(false);
  const [showcat, setShowcat] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const googleMapsApiKey = "AIzaSyCq1eeQipLUK-43-lJPCGWIZAVzJuuhWpY";

  // Load data from localStorage on mount
  const didLoadData = useRef(false);

  // ✅ 1. Load from localStorage once on mount
  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("formmData"));
    if (storedData) {
      setJobtitle(storedData.jobtitle || "");
      setTime(storedData.time || "");
      setJobdescription(storedData.jobdescription || "");
      setServiceType(storedData.serviceType || "");
      setDate(storedData.date ? moment(storedData.date) : null);
      setSelecttday(storedData.selecttday || "");
      setAddress(storedData.address || "");
      setImages(storedData.images || []);
      setActiveprofile(storedData.activeprofile || null);
    }
    // ✅ Mark as loaded after restoring
    didLoadData.current = true;
  }, []);

  // ✅ 2. Save to localStorage anytime form data changes
  useEffect(() => {
    // ⛔ Skip saving on the very first load (to avoid overwriting)
    if (!didLoadData.current) return;

    const existingData = JSON.parse(localStorage.getItem("formmData")) || {};

    const formData = {
      ...existingData,
      jobtitle,
      jobdescription,
      serviceType,
      date: date ? date.toISOString() : null,
      selecttday,
      time,
      address,
      images,
      activeprofile,
    };
    localStorage.setItem("formmData", JSON.stringify(formData));
  }, [
    jobtitle,
    jobdescription,
    serviceType,
    date,
    selecttday,
    address,
    images,
    activeprofile,
    time,
  ]);

  useEffect(() => {
    const db = getDatabase();
    const categoriesRef = ref(db, "categories");

    const unsubscribe = onValue(categoriesRef, (snapshot) => {
      const data = snapshot.val();
      const allServices = [];

      if (data) {
        Object.values(data).forEach((category) => {
          if (category.services) {
            Object.values(category.services).forEach((service) => {
              if (service.name) {
                allServices.push(service.name);
              }
            });
          }
        });
      }

      setServices(allServices);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const techRef = ref(db, "technicians");

    // Listen to changes in technicians data
    onValue(techRef, (snapshot) => {
      if (snapshot.exists()) {
        const techArray = Object.entries(snapshot.val()).map(([id, tech]) => ({
          id,
          ...tech,
        }));

        const approved = techArray.filter(
          (tech) =>
            tech.approval === "accepted" &&
            tech.bio === false &&
            tech.pricing === false
        );

        console.log("Approved Technicians: ", approved);

        // Filter technicians based on the serviceType selected
        const withServicePrice = approved
          .map((tech) => {
            const match = tech.services?.find(
              (s) => s.name?.toLowerCase() === serviceType?.toLowerCase()
            );

            if (match) {
              return {
                ...tech,
                servicePrice: Number(match.price),
              };
            } else {
              return null;
            }
          })
          .filter((tech) => tech !== null);

        if (withServicePrice.length === 0) {
          setFilteredTechnicians([]);
        } else {
          setTechnicians(withServicePrice);
          setFilteredTechnicians(withServicePrice);
        }
      }
    });
  }, [serviceType]);

  useEffect(() => {
    let filtered = technicians.filter((tech) => {
      if (minPrice && tech.servicePrice < Number(minPrice)) return false;
      if (maxPrice && tech.servicePrice > Number(maxPrice)) return false;

      if (
        selectedLevel &&
        tech.level?.toLowerCase() !== selectedLevel.toLowerCase()
      )
        return false;

      if (minExperience && Number(tech.expyears || 0) < Number(minExperience))
        return false;

      if (minRating && Number(tech.rating || 0) < Number(minRating))
        return false;

      return true;
    });

    setFilteredTechnicians(filtered);
  }, [
    technicians,
    minPrice,
    maxPrice,
    selectedLevel,
    minExperience,
    minRating,
  ]);

  function formatDate(dateString) {
    const date = new Date(dateString);
    // Arrays for the short names of days and months.
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Get the components of the date.
    const dayName = days[date.getDay()];
    const monthName = months[date.getMonth()];
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();

    return `${dayName}, ${monthName} ${day}, ${year}`;
  }

  const formatPrice = (price) => {
    if (!price) return "";
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  // Filter items based on the search term
  const filteredItems = services.filter((item) =>
    item.toLowerCase().includes(serviceType.toLowerCase())
  );

  const handlePlaceChanged = () => {
    if (autocomplete) {
      const place = autocomplete.getPlace();
      if (place?.formatted_address) {
        setAddress(place.formatted_address);
      }
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  const morning = ["7am", "8am", "9am"];
  const midday = ["10am", "11am", "12pm", "1pm", "2pm"];
  const afternoon = ["3pm", "4pm", "5pm", "6pm"];
  const evening = ["7pm", "8pm", "9pm"];

  // Handle file input change
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const newImages = files.map((file) => ({
      id: file.name + "-" + file.lastModified,
      file,
      preview: URL.createObjectURL(file),
    }));
    setImages((prevImages) => [...prevImages, ...newImages]);
  };

  // Delete an image
  const handleDeleteImage = (id) => {
    setImages((prevImages) =>
      prevImages.filter((img) => {
        if (img.id === id) {
          URL.revokeObjectURL(img.preview);
          return false;
        }
        return true;
      })
    );
  };

  const selectTechnician = () => {
    const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
      if (authUser) {
        const userSnapshot = await get(ref(db, `users/${authUser.uid}`));
        const technicianSnapshot = await get(
          ref(db, `technicians/${authUser.uid}`)
        );

        if (userSnapshot.exists()) {
          navigate("/client/dashboard");
        } else if (technicianSnapshot.exists()) {
          navigate("/technician/dashboard");
        } else {
          navigate("/login");
        }
      } else {
        navigate("/login");
      }
    });

    return () => unsubscribe();
  };

  // const getCoordinates = () =>
  //   new Promise((resolve, reject) => {
  //     if (!navigator.geolocation) {
  //       return reject(
  //         new Error("Geolocation is not supported by your browser.")
  //       );
  //     }
  //     navigator.geolocation.getCurrentPosition(resolve, reject, {
  //       enableHighAccuracy: true,
  //       timeout: 10000,
  //       maximumAge: 0,
  //     });
  //   });

  // Cleanup object URLs when component unmounts
  useEffect(() => {
    return () => {
      images.forEach((img) => URL.revokeObjectURL(img.preview));
    };
  }, [images]);

  const handleClose = () => {
    console.log("Modal is closing now 🛑");
    // Example: clear form data or localStorage
    localStorage.removeItem("formData");

    if (onClose) {
      onClose(); // Important: call the parent’s close handler
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const user = auth.currentUser;
    if (!user) {
      alert("User not authenticated.");
      navigate("/login");
      return;
    }

    if (
      !serviceType ||
      !jobtitle ||
      !jobdescription ||
      !address ||
      !activeprofile ||
      !time
    ) {
      alert("Please fill in all required fields.");
      return;
    }

    try {
      setLoading(true);

      // Get current location
      // const position = await getCoordinates();
      // const { latitude, longitude } = position.coords;

      // Retrieve the user's name from the database
      const userSnapshot = await get(ref(db, `users/${user.uid}`));
      const userName = userSnapshot.exists() ? userSnapshot.val().name : "";
      const userSurname = userSnapshot.exists() ? userSnapshot.val().lastName : "";

      // Upload images to Firebase Storage and get URLs
      const uploadedImageURLs = await Promise.all(
        images.map(async (img, index) => {
          try {
            const imageRef = storageRef(
              storage,
              `jobImages/${user.uid}/${Date.now()}_${index}`
            );
            await uploadBytes(imageRef, img.file);
            return await getDownloadURL(imageRef);
          } catch (error) {
            console.error("Error uploading image:", error);
            return null; // Skip failed uploads
          }
        })
      ).then((urls) => urls.filter((url) => url !== null)); // Filter out failed uploads

      // Build the job object
      const newJob = {
        userId: user.uid,
        userName,
        userSurname,
        taskcreated: Date.now(),
        status: "pending",
        createdAt: Date.now(),
        // location: { lat: latitude, lng: longitude },
        serviceType,
        timeOfDay: selecttday,
        time,
        address,
        images: uploadedImageURLs,
        jobtitle,
        jobdescription,
        date: date ? date.toISOString() : null,
        activeprofile,
        technicianId: activeprofile.id,
        hourlyRate: activeprofile.servicePrice,
        trustSupportFee: 8000,
        totalFee: activeprofile.servicePrice + 8000,
      };

      // Push job data to Firebase Realtime Database
      await push(ref(db, "jobs"), newJob);
      // CLEAR localStorage now that the job is submitted
      localStorage.removeItem("formmData");
      // Navigate to dashboard after successful submission
      handleClose();
      navigate(`/client/dashboard`);
    } catch (error) {
      console.error("Error posting job:", error.message);
      alert(
        "An error occurred while posting the job. Please check your internet connection and ensure location access is allowed."
      );
    } finally {
      setLoading(false);
    }
  };
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey,
    libraries: ["places"],
  });

  if (loadError) {
    return null; // or show an error boundary
  }

  if (!isLoaded) {
    return null; // ⛔️ no loading indicator
  }

  if (!isOpen) return null;
  if (loading) return <Loader />;
  return (
    <>
      <div className='modal-overlay' onClick={handleClose}>
        <div
          className='modal-content'
          onClick={(e) => e.stopPropagation()} // Prevent closing on content click
        >
          <button className='modal-close' onClick={onClose}>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              viewBox='0 0 24 24'
              width='26'
              height='26'
              fill='currentColor'
            >
              <path d='M10.5859 12L2.79297 4.20706L4.20718 2.79285L12.0001 10.5857L19.793 2.79285L21.2072 4.20706L13.4143 12L21.2072 19.7928L19.793 21.2071L12.0001 13.4142L4.20718 21.2071L2.79297 19.7928L10.5859 12Z'></path>
            </svg>
          </button>
          {active === "jobtitledescription" && (
            <div className='jobtitledescription'>
              <div className='inputjobcnt'>
                <h1>In a few words. what do you need done?</h1>
                <input
                  type='text'
                  name='jobtitle'
                  value={jobtitle}
                  onChange={(e) => setJobtitle(e.target.value)}
                  placeholder='Job title'
                />
              </div>
              <div className='thespacee'></div>
              <div className='inputjobcnt'>
                <h1>What are the details?</h1>
                <input
                  type='text'
                  name='jobdescription'
                  value={jobdescription}
                  onChange={(e) => setJobdescription(e.target.value)}
                  placeholder='Job description'
                />
              </div>
              <div className='thespacee'></div>
              <div className='thespacee'></div>
              {jobtitle.length > 0 && jobdescription.length > 0 && (
                <div className='thebtnss'>
                  <button
                    className='cntbtn'
                    onClick={() => setActive("servicetype")}
                  >
                    Continue
                  </button>
                  <button className='canbtn' onClick={onClose}>
                    Cancel
                  </button>
                </div>
              )}
            </div>
          )}
          {active === "servicetype" && (
            <div className='servicetype'>
              <h1>What is the service type?</h1>
              <div className='inputjobcntselect'>
                <div className='inputsecls'>
                  <input
                    type='text'
                    placeholder='What do you need help with?'
                    value={serviceType}
                    onChange={(e) => {
                      setServiceType(e.target.value);
                      setShowSearchlist(true);
                    }}
                  />
                </div>
                {showSearchlist && (
                  <>
                    <div
                      className='invibg'
                      onClick={() => setShowSearchlist(false)}
                    ></div>
                    <div className='searchinputcont'>
                      {filteredItems.length === 0 && (
                        <p>Sorry we don't offer this type of service.</p>
                      )}
                      {filteredItems.map((item, index) => (
                        <div
                          className='serchsasitem'
                          key={index}
                          onClick={() => {
                            setServiceType(item);
                            setShowSearchlist(!showSearchlist);
                          }}
                        >
                          <p key={index}>{item}</p>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
              <div className='thespacee'></div>
              {serviceType.length > 0 && serviceType.length > 4 && (
                <div className='thebtnss'>
                  <div className='cntnext'>
                    <button
                      className='canbtn'
                      onClick={() => setActive("jobtitledescription")}
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        viewBox='0 0 24 24'
                        width='24'
                        height='24'
                        fill='#111'
                      >
                        <path d='M22.0003 13.0001L22.0004 11.0002L5.82845 11.0002L9.77817 7.05044L8.36396 5.63623L2 12.0002L8.36396 18.3642L9.77817 16.9499L5.8284 13.0002L22.0003 13.0001Z'></path>
                      </svg>
                    </button>
                    <button
                      className='cntbtn'
                      onClick={() => setActive("date")}
                    >
                      Continue
                    </button>
                  </div>

                  <button className='canbtn' onClick={onClose}>
                    Cancel
                  </button>
                </div>
              )}
            </div>
          )}
          {active === "date" && (
            <div className='jobtitledescription'>
              <div className='inputjobcnt'>
                <h1>When do you need this done?</h1>
                <div
                  className='
              '
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <DatePicker
                    selected={date}
                    onChange={(date) => setDate(date)}
                    dateFormat='MMMM d, yyyy'
                    placeholderText='Click to select a date'
                    minDate={new Date()} // prevent past dates
                    maxDate={new Date(2025, 11, 31)} // custom max date
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode='select'
                    isClearable
                    className='my-datepicker'
                  />
                </div>
              </div>
              <div className='thespacee'></div>
              <div className='thespacee'></div>
              {date && (
                <div className='thebtnss'>
                  <div className='cntnext'>
                    <button
                      className='canbtn'
                      onClick={() => setActive("servicetype")}
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        viewBox='0 0 24 24'
                        width='24'
                        height='24'
                        fill='#111'
                      >
                        <path d='M22.0003 13.0001L22.0004 11.0002L5.82845 11.0002L9.77817 7.05044L8.36396 5.63623L2 12.0002L8.36396 18.3642L9.77817 16.9499L5.8284 13.0002L22.0003 13.0001Z'></path>
                      </svg>
                    </button>
                    <button
                      className='cntbtn'
                      onClick={() => setActive("timeofday")}
                    >
                      Continue
                    </button>
                  </div>

                  <button className='canbtn' onClick={onClose}>
                    Cancel
                  </button>
                </div>
              )}
            </div>
          )}
          {active === "timeofday" && (
            <div className='jobtitledescription'>
              <div className='inputjobcnt'>
                <h1>What time of the day do you want it to start?</h1>
                <div className='thespacee'></div>
                <div className='thechoose'>
                  <div
                    onClick={() => setSelecttday("morning")}
                    className={
                      selecttday === "morning"
                        ? "selectactive"
                        : "selectnotactive"
                    }
                  >
                    <p className='seact'>Morning</p>{" "}
                    <p className='seactn'>Before 10am</p>
                  </div>
                  <div
                    onClick={() => setSelecttday("midday")}
                    className={
                      selecttday === "midday"
                        ? "selectactive"
                        : "selectnotactive"
                    }
                  >
                    <p className='seact'>Midday</p>{" "}
                    <p className='seactn'>10am - 2pm</p>
                  </div>
                  <div
                    onClick={() => setSelecttday("afternoon")}
                    className={
                      selecttday === "afternoon"
                        ? "selectactive"
                        : "selectnotactive"
                    }
                  >
                    <p className='seact'>Afternoon</p>{" "}
                    <p className='seactn'>2pm - 6pm</p>
                  </div>
                  <div
                    onClick={() => setSelecttday("evening")}
                    className={
                      selecttday === "evening"
                        ? "selectactive"
                        : "selectnotactive"
                    }
                  >
                    <p className='seact'>Evening</p>{" "}
                    <p className='seactn'>After 6pm</p>
                  </div>
                </div>
              </div>
              <div className='thespacee'></div>
              {selecttday === "morning" && (
                <div className='seldasy'>
                  {morning.map((mn) => (
                    <p
                      className={time === mn ? "activemn" : "notactivemn"}
                      onClick={() => setTime(mn)}
                    >
                      {mn}
                    </p>
                  ))}
                </div>
              )}
              {selecttday === "midday" && (
                <div className='seldasy'>
                  {midday.map((mn) => (
                    <p
                      className={time === mn ? "activemn" : "notactivemn"}
                      onClick={() => setTime(mn)}
                    >
                      {mn}
                    </p>
                  ))}
                </div>
              )}
              {selecttday === "afternoon" && (
                <div className='seldasy'>
                  {afternoon.map((mn) => (
                    <p
                      className={time === mn ? "activemn" : "notactivemn"}
                      onClick={() => setTime(mn)}
                    >
                      {mn}
                    </p>
                  ))}
                </div>
              )}
              {selecttday === "evening" && (
                <div className='seldasy'>
                  {evening.map((mn) => (
                    <p
                      className={time === mn ? "activemn" : "notactivemn"}
                      onClick={() => setTime(mn)}
                    >
                      {mn}
                    </p>
                  ))}
                </div>
              )}
              <div className='thespacee'></div>
              <div className='thespacee'></div>
              {selecttday.length > 0 && time.length > 0 && (
                <div className='thebtnss'>
                  <div className='cntnext'>
                    <button
                      className='canbtn'
                      onClick={() => setActive("date")}
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        viewBox='0 0 24 24'
                        width='24'
                        height='24'
                        fill='#111'
                      >
                        <path d='M22.0003 13.0001L22.0004 11.0002L5.82845 11.0002L9.77817 7.05044L8.36396 5.63623L2 12.0002L8.36396 18.3642L9.77817 16.9499L5.8284 13.0002L22.0003 13.0001Z'></path>
                      </svg>
                    </button>
                    <button
                      className='cntbtn'
                      onClick={() => setActive("address")}
                    >
                      Continue
                    </button>
                  </div>

                  <button className='canbtn' onClick={onClose}>
                    Cancel
                  </button>
                </div>
              )}
            </div>
          )}
          {active === "address" && (
            <div className='jobtitledescription'>
              <div className='inputjobcnt'>
                <h1>Tell us where</h1>
                <Autocomplete
                  onLoad={(autocomplete) => setAutocomplete(autocomplete)}
                  onPlaceChanged={handlePlaceChanged}
                  options={{
                    componentRestrictions: { country: "NG" }, // Restrict to Nigeria
                  }}
                >
                  <input
                    type='text'
                    name='address'
                    placeholder='Enter your address'
                    id='address'
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    className='autocomplete-input'
                  />
                </Autocomplete>
              </div>
              <div className='thespacee'></div>
              <div className='thespacee'></div>
              <div className='thespacee'></div>
              {address.length > 0 && (
                <div className='thebtnss'>
                  <div className='cntnext'>
                    <button
                      className='canbtn'
                      onClick={() => setActive("timeofday")}
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        viewBox='0 0 24 24'
                        width='24'
                        height='24'
                        fill='#111'
                      >
                        <path d='M22.0003 13.0001L22.0004 11.0002L5.82845 11.0002L9.77817 7.05044L8.36396 5.63623L2 12.0002L8.36396 18.3642L9.77817 16.9499L5.8284 13.0002L22.0003 13.0001Z'></path>
                      </svg>
                    </button>
                    <button
                      className='cntbtn'
                      onClick={() => setActive("uploadimages")}
                    >
                      Continue
                    </button>
                  </div>

                  <button className='canbtn' onClick={onClose}>
                    Cancel
                  </button>
                </div>
              )}
            </div>
          )}
          {active === "uploadimages" && (
            <div className='jobtitledescription'>
              <div className='inputjobcnt'>
                <h1>Show us how the task looks like</h1>
                <div className='theimageinputcnt'>
                  <div className='custom-file-input'>
                    <input
                      type='file'
                      id='imageUpload'
                      name='images'
                      multiple
                      accept='image/*'
                      onChange={handleFileChange}
                    />
                    <label htmlFor='imageUpload'>
                      <span className='upload-text'>+</span>
                    </label>
                  </div>
                  <div className='preview-container'>
                    {images.length > 0 ? (
                      images.map((img) => (
                        <div key={img.id} className='preview-item'>
                          <img
                            src={img.preview}
                            alt='Preview'
                            className='previewimg'
                          />
                          <button
                            onClick={() => handleDeleteImage(img.id)}
                            className='imgdeleteicon'
                          >
                            x
                          </button>
                        </div>
                      ))
                    ) : (
                      <p>No images uploaded.</p>
                    )}
                  </div>
                </div>
              </div>
              <div className='thespacee'></div>
              <div className='thespacee'></div>
              <div className='thespacee'></div>

              <div className='thebtnss'>
                <div className='cntnext'>
                  <button
                    className='canbtn'
                    onClick={() => setActive("address")}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      viewBox='0 0 24 24'
                      width='24'
                      height='24'
                      fill='#111'
                    >
                      <path d='M22.0003 13.0001L22.0004 11.0002L5.82845 11.0002L9.77817 7.05044L8.36396 5.63623L2 12.0002L8.36396 18.3642L9.77817 16.9499L5.8284 13.0002L22.0003 13.0001Z'></path>
                    </svg>
                  </button>
                  <button
                    className='cntbtn'
                    onClick={() => setActive("technicians")}
                  >
                    Continue
                  </button>
                </div>

                <button className='canbtn' onClick={onClose}>
                  Cancel
                </button>
              </div>
            </div>
          )}
          {active === "technicians" && (
            <div className='technicianscnt'>
              <div className='inputjobcnt'>
                <h1>Technicians Available</h1>
                <div className='booktp'>
                  <p className='booktptitle'>Filter</p>
                  <button
                    className='booktpfilt'
                    onClick={() => setShowcat(true)}
                  >
                    <img src={filetericon} alt='' />
                  </button>
                </div>
                <div className='thespace'></div>
                <div className='selettechcrdcnt'>
                  {filteredTechnicians.length > 0 ? (
                    filteredTechnicians.map((tech) => (
                      <div
                        key={tech?.id}
                        className='selettechcard'
                        onClick={() => setActiveprofile(tech)}
                      >
                        <div className='selettechcardtop'>
                          <div className='selctopleft'>
                            <img
                              className='selctprofurl'
                              src={tech?.profileUrl}
                              alt=''
                            />
                            <div
                              className={
                                tech?.rating > 3.5
                                  ? "wlitoprgreen"
                                  : "wlitopryellow"
                              }
                            >
                              <svg
                                width='12'
                                height='12'
                                viewBox='0 0 15 15'
                                fill='#fff'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <path
                                  d='M7.22303 0.665992C7.32551 0.419604 7.67454 0.419604 7.77702 0.665992L9.41343 4.60039C9.45663 4.70426 9.55432 4.77523 9.66645 4.78422L13.914 5.12475C14.18 5.14607 14.2878 5.47802 14.0852 5.65162L10.849 8.42374C10.7636 8.49692 10.7263 8.61176 10.7524 8.72118L11.7411 12.866C11.803 13.1256 11.5206 13.3308 11.2929 13.1917L7.6564 10.9705C7.5604 10.9119 7.43965 10.9119 7.34365 10.9705L3.70718 13.1917C3.47945 13.3308 3.19708 13.1256 3.25899 12.866L4.24769 8.72118C4.2738 8.61176 4.23648 8.49692 4.15105 8.42374L0.914889 5.65162C0.712228 5.47802 0.820086 5.14607 1.08608 5.12475L5.3336 4.78422C5.44573 4.77523 5.54342 4.70426 5.58662 4.60039L7.22303 0.665992Z'
                                  fill='#fff'
                                ></path>
                              </svg>
                              <p className='ratingnum'>{tech?.rating}</p>
                            </div>
                          </div>
                          <div className='selctopright'>
                            <h4 className='selctoprightitle'>
                              {tech?.name} {tech?.lastName}
                            </h4>{" "}
                            <div className='selctoprightbtm'>
                              <p
                                className={
                                  tech?.level === "great value"
                                    ? "jdtechgreat"
                                    : "elite"
                                }
                              >
                                {tech?.level}
                              </p>
                              <p className='jdtechminum'>2 HOUR MAXIMUM</p>
                            </div>
                          </div>
                        </div>
                        <div className='expviewprofile'>
                          <p className='expyears'>
                            {tech?.expyears} Years experience
                          </p>
                          {/* <button
                      className='expviewbtn'
                      onClick={() => setActiveprofile(tech)}
                    >
                      View profile <img src={forwardicon} alt='' />
                    </button> */}
                        </div>
                        <div className='thespace'></div>
                        <div className='selettetechbkpr'>
                          <p className='selpric'>
                            ₦{formatPrice(tech?.servicePrice)}/hr
                          </p>
                          {/* <button
                      className='selbkpr'
                      onClick={() => selectTechnician(tech.id)}
                    >
                      Book and continue
                    </button> */}
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No technicians available for the selected service.</p>
                  )}
                </div>
              </div>
              <div className='thespacee'></div>
              <div className='thespacee'></div>
              <div className='thespacee'></div>
            </div>
          )}
        </div>
      </div>
      {activeprofile && (
        <>
          <div className='profilemodal' onClick={() => setActiveprofile(null)}>
            <div className='profilebody' onClick={(e) => e.stopPropagation()}>
              <button
                className='profile-close'
                onClick={() => setActiveprofile(null)}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 24 24'
                  width='32'
                  height='32'
                  fill='currentColor'
                >
                  <path d='M10.5859 12L2.79297 4.20706L4.20718 2.79285L12.0001 10.5857L19.793 2.79285L21.2072 4.20706L13.4143 12L21.2072 19.7928L19.793 21.2071L12.0001 13.4142L4.20718 21.2071L2.79297 19.7928L10.5859 12Z'></path>
                </svg>
              </button>
              <div className='jdtechasleft'>
                <img
                  src={activeprofile.profileUrl}
                  alt=''
                  className='jdtechimg'
                />
                <div className='thesepare'>
                  <div className='jdtechpro'>
                    <h1 className='jdtechproname'>
                      {activeprofile.name} {activeprofile.lastName}
                    </h1>
                    <div
                      className={
                        activeprofile.rating > 3.5
                          ? "wlitoprgreen"
                          : "wlitopryellow"
                      }
                    >
                      <svg
                        width='12'
                        height='12'
                        viewBox='0 0 15 15'
                        fill='#fff'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M7.22303 0.665992C7.32551 0.419604 7.67454 0.419604 7.77702 0.665992L9.41343 4.60039C9.45663 4.70426 9.55432 4.77523 9.66645 4.78422L13.914 5.12475C14.18 5.14607 14.2878 5.47802 14.0852 5.65162L10.849 8.42374C10.7636 8.49692 10.7263 8.61176 10.7524 8.72118L11.7411 12.866C11.803 13.1256 11.5206 13.3308 11.2929 13.1917L7.6564 10.9705C7.5604 10.9119 7.43965 10.9119 7.34365 10.9705L3.70718 13.1917C3.47945 13.3308 3.19708 13.1256 3.25899 12.866L4.24769 8.72118C4.2738 8.61176 4.23648 8.49692 4.15105 8.42374L0.914889 5.65162C0.712228 5.47802 0.820086 5.14607 1.08608 5.12475L5.3336 4.78422C5.44573 4.77523 5.54342 4.70426 5.58662 4.60039L7.22303 0.665992Z'
                          fill='#fff'
                        ></path>
                      </svg>
                      <p className='ratingnum'>{activeprofile.rating}</p>
                    </div>
                  </div>
                  <p className='jdtechgreat'>{activeprofile.level}</p>
                  <p className='jdtechminum'>2 HOUR MINIMUM</p>
                </div>
              </div>
              <div className='thespacee'></div>
              <div className='divider'></div>
              <div className='thespacee'></div>
              <p className='profiletopic'>Bio</p>
              <div className='thespace'></div>
              <p className='profilesentence'>{activeprofile.aboutme}</p>
              <div className='thegap'></div>
              <div className='selettetechbkprr'>
                <p className='selpric'>
                  ₦{formatPrice(activeprofile.servicePrice)}/hr
                </p>
                <button className='selbkpr' onClick={() => setTasksum(true)}>
                  Book and continue
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      {showcat && (
        <>
          <div className='downmodal' onClick={() => setShowcat(false)}></div>
          <div className='downmodalbody'>
            <div className='downmodalway'>
              <div className='thegap'></div>
              <div className='bttsleft'>
                <div className='thetechtops'>
                  <h2 className='bttslefttitle'>Filter professionals</h2>
                  <button onClick={() => setShowcat(false)}>
                    <IoCloseOutline />
                  </button>
                </div>

                <div className='thespacee'></div>
                <div className='bttsleftitems'>
                  <div className='ylinputform'>
                    <p className='bttsdftitle'>Technician level</p>
                    <div className='techlevelsep'>
                      <div
                        className={
                          selectedLevel === "elite"
                            ? "tskitemactive"
                            : "tskitemnotactive"
                        }
                        onClick={() => setSelectedLevel("elite")}
                      >
                        <img
                          src={selectedLevel === "elite" ? checked : unchecked}
                          alt=''
                        />
                        <div className='tskitemleft'>
                          <label className='tskla'>Elite</label>
                        </div>
                      </div>

                      <div
                        className={
                          selectedLevel === "great value"
                            ? "tskitemactive"
                            : "tskitemnotactive"
                        }
                        onClick={() => setSelectedLevel("great value")}
                      >
                        <img
                          src={
                            selectedLevel === "great value"
                              ? checked
                              : unchecked
                          }
                          alt=''
                        />
                        <div className='tskitemleft'>
                          <label className='tskla'>Great Value</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='thegap'></div>
                  <div className='inputcnt'>
                    <label htmlFor=''>Years of experience</label>
                    <input
                      type='number'
                      placeholder='Min Experience'
                      value={minExperience}
                      onChange={(e) => setMinExperience(e.target.value)}
                    />
                  </div>
                  <div className='thegap'></div>
                  <div className='theflexs'>
                    <div className='inputcnt'>
                      <label htmlFor=''>Min price</label>
                      <input
                        type='number'
                        placeholder='Min Price'
                        value={minPrice}
                        onChange={(e) => setMinPrice(e.target.value)}
                      />
                    </div>
                    <div className='inputcnt'>
                      <label htmlFor=''>Max price</label>
                      <input
                        type='number'
                        placeholder='Max Price'
                        value={maxPrice}
                        onChange={(e) => setMaxPrice(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className='thespacee'></div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {tasksum && (
        <>
          <div className='summodal'></div>
          <div className='sumbody'>
            <div className='sumbodycnt'>
              <div className='sumtop'>
                <button
                  className='profile-close'
                  onClick={() => setTasksum(false)}
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    viewBox='0 0 24 24'
                    width='32'
                    height='32'
                    fill='#fff'
                  >
                    <path d='M10.5859 12L2.79297 4.20706L4.20718 2.79285L12.0001 10.5857L19.793 2.79285L21.2072 4.20706L13.4143 12L21.2072 19.7928L19.793 21.2071L12.0001 13.4142L4.20718 21.2071L2.79297 19.7928L10.5859 12Z'></path>
                  </svg>
                </button>
              </div>
              <div className='thespace'></div>
              <h1 className='sumttitle'>Task Summary</h1>
              <div className='thespacee'></div>
              <div className='thespacee'></div>
              <p className='profidestitle'>Technician Details</p>
              <div className='thespace'></div>
              <div className='profilenaimg'>
                <img src={activeprofile?.profileUrl} alt='' />
                <h1 className='sumpara'>{activeprofile?.name} {activeprofile?.lastName}</h1>
              </div>
              <div className='thespace'></div>

              <div className='thespace'></div>
              <p className='profidestitle'>Task title</p>
              <div className='thespace'></div>
              <p className='proffdes'>{jobtitle}</p>
              <div className='thespacee'></div>
              <p className='profidestitle'>Your task details</p>

              <div className='thespace'></div>
              <p className='proff'>{jobdescription}</p>
              <div className='thespace'></div><div className="thespacee"></div>
              <div className='profitems'>
                <img src={timeicon} alt='' className='pritemimg' />
                {selecttday === "morning" && (
                  <p>
                    {selecttday} <span>Before 10am</span>
                  </p>
                )}
                {selecttday === "midday" && (
                  <p>
                    {selecttday} <span>10am - 2pm</span>
                  </p>
                )}
                {selecttday === "afternoon" && (
                  <p>
                    {selecttday} <span>2pm - 6pm</span>
                  </p>
                )}
                {selecttday === "evening" && (
                  <p>
                    {selecttday} <span>After 6pm</span>
                  </p>
                )}
              </div>
              
              <div className='profitems'>
                <img src={calendericon} alt='' className='pritemimg' />
                <p>{formatDate(date)}</p>
              </div>
              <div className='profitems'>
                <img src={locationicon} alt='' className='pritemimg' />
                <p>{address}</p>
              </div>
              <div className='thespace'></div>
              <div className='thespace'></div>
              <p className='profidestitle'>Price Details</p>
              <div className='thespace'></div>
              <div className='theprdet'>
                <div className='prodestri'>
                  <p className='prodeslef'>Hourly rate</p>
                  <p className='prodesright'>
                    ₦{formatPrice(activeprofile?.servicePrice)}/hr
                  </p>
                </div>
                <div className='prodestri'>
                  <p className='prodeslef'>Trust/support fee</p>
                  <p className='prodesright'> ₦8,000</p>
                </div>
                <div className='prodestri'>
                  <p className='prodeslef'>Total fee</p>
                  <p className='prodesright'>
                    ₦{formatPrice(activeprofile?.servicePrice + 8000)}
                  </p>
                </div>
              </div>
              <div className='thespacee'></div>
              <div className="thespacee"></div>
              <button className='selbkprr' onClick={handleSubmit}>
                Continue to payment
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default PostJob;
